/** @jsxImportSource @emotion/react */
import { Pagination as MantinePagination } from '@mantine/core';
import { useTheme } from '../../ThemeProvider';
import { Typography } from '../Typography';

export interface Props {
  currentPage: number;
  onChange: (value: number) => void;
  numberOfElements: number;
  pageSize: number;
}

export const Pagination = ({
  currentPage,
  onChange,
  numberOfElements,
  pageSize,
}: Props) => {
  const { spacing, palette } = useTheme();

  const numberOfPages = Math.ceil(numberOfElements / pageSize);
  const firstElementOfPage = (currentPage - 1) * pageSize + 1;
  const lastElementOfPage = Math.min(
    firstElementOfPage + pageSize - 1,
    numberOfElements
  );
  return (
    <div
      css={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: spacing.xxxs,
      }}
    >
      <Typography
        variant="bodySmall"
        color={palette.grey.x300}
      >{`${firstElementOfPage}-${lastElementOfPage} of ${numberOfElements} Results`}</Typography>
      <MantinePagination
        value={currentPage}
        onChange={onChange}
        total={numberOfPages}
        css={{
          '.mantine-Pagination-control': {
            background: 'none',
            border: 'none',
            color: palette.grey.default,
            fontWeight: 500,
            '&[data-active]': {
              color: palette.black,
              background: palette.white,
              border: `1px solid ${palette.grey.x100}`,
            },
            ':hover': {
              background: `${palette.white} !important`,
            },
          },
        }}
      />
    </div>
  );
};
